// extracted by mini-css-extract-plugin
export default {"container":"noteForm_container__UCYZR","fields":"noteForm_fields__9jhO-","buttons":"noteForm_buttons__6hFM0"};